import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { InventoryAlert, AutoPurchase, PurchaseOptimizerItem } from '../../shared/models/general';

import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InventoryRequestService {
  private apiUrl = `${environment.apiUrl}/inventory_requests`;
  public refreshRequests$ = new Subject<void>();

  constructor(private http: HttpClient) { }

  getInventoryAlerts(companyId: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/alert/${companyId}`);
  }

  createInventoryAlert(alert: InventoryAlert): Observable<any> {
    return this.http.post(`${this.apiUrl}/alert`, alert);
  }

  updateInventoryAlert(id: string, alert: InventoryAlert): Observable<any> {
    return this.http.put(`${this.apiUrl}/alert/${id}`, alert);
  }

  getAutoPurchases(companyId: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/auto-purchase/${companyId}`);
  }

  createAutoPurchase(autoPurchase: AutoPurchase): Observable<any> {
    return this.http.post(`${this.apiUrl}/auto-purchase`, autoPurchase);
  }

  updateAutoPurchase(id: string, autoPurchase: AutoPurchase): Observable<any> {
    return this.http.put(`${this.apiUrl}/auto-purchase/${id}`, autoPurchase);
  }

  deleteInventoryAlert(id: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/alert/${id}`);
  }

  closeInventoryAlert(id: string): Observable<any> {
    return this.http.put(`${this.apiUrl}/alert/${id}/close`, {});
  }

  deleteAutoPurchase(id: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/auto-purchase/${id}`);
  }

  // --- Purchase Optimizer Items ---
  getPurchaseOptimizerItems(companyId: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/purchase-optimizer/${companyId}`);
  }

  createOptimizedSalesOrder(companyId: string): Observable<any> {
    return this.http.post(`${this.apiUrl}/purchase-optimizer/${companyId}/optimize-sales-order`, {});
  }

  createPurchaseOptimizerItem(item: PurchaseOptimizerItem): Observable<any> {
    return this.http.post(`${this.apiUrl}/purchase-optimizer`, item);
  }

  updatePurchaseOptimizerItem(id: string, item: PurchaseOptimizerItem): Observable<any> {
    return this.http.put(`${this.apiUrl}/purchase-optimizer/${id}`, item);
  }

  deletePurchaseOptimizerItem(id: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/purchase-optimizer/${id}`);
  }

  resetPurchaseOptimization(companyId: string): Observable<any> {
    return this.http.post(`${this.apiUrl}/purchase-optimizer/${companyId}/reset`, {});
  }

  getAllManufacturers(): Observable<string[]> {
    return this.http.get<string[]>(`${environment.apiUrl}/live_inventories/manufacturers`);
  }

  searchAdvancedInventory(manufacturer: string, description: string): Observable<any[]> {
    return this.http.post<any[]>(`${environment.apiUrl}/live_inventories/search-advanced`, {
      manufacturer,
      description
    });
  }
}
